export const GET_DOORMEN = 'school/GET_DOORMEN'
export const GET_DOORMEN_SUCCESSFUL = 'school/GET_DOORMEN_SUCCESSFUL'
export const GET_DOORMEN_FAILURE = 'school/GET_DOORMEN_FAILURE'

export const CREATE_DOORMAN = 'school/CREATE_DOORMAN'
export const CREATE_DOORMAN_SUCCESSFUL = 'school/CREATE_DOORMAN_SUCCESSFUL'
export const CREATE_DOORMAN_FAILURE = 'school/CREATE_DOORMAN_FAILURE'

export const CLEAR_DOORMAN_REDUCER = 'school/CLEAR_DOORMAN_REDUCER'

export const REMOVE_DOORMAN_RSPA = 'rspa: school/REMOVE_DOORMAN_RSPA'
